import { render } from "./TheDemandActionButton4.vue?vue&type=template&id=30b003e4"
import script from "./TheDemandActionButton4.vue?vue&type=script&lang=js"
export * from "./TheDemandActionButton4.vue?vue&type=script&lang=js"
script.render = render

export default script